import { render, staticRenderFns } from "./OrderProductTable.vue?vue&type=template&id=a9fa6ac4"
import script from "./OrderProductTable.vue?vue&type=script&lang=ts"
export * from "./OrderProductTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports